<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeTopSpender"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeTopSpender" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <div class="w-100 d-flex justify-center pa-6">
      <v-card
        class="w-100 d-flex flex-column justify-center align-center table-show"
        style="padding: 24px 0px; z-index: 1"
        rounded="xl"
      >
        <h2 class="text-center font-weight-medium">
          {{
            $t("microsite.textTopRankingCampaign", {
              num: campaign?.top_spender_number,
            })
          }}
        </h2>
        <v-alert
          text
          dense
          color="orange"
          class="ma-1"
          border="left"
          v-if="
            userData?.choose_lucky_draw &&
            !campaign?.is_split_lucky_draw_top_ranking
          "
        >
          <span class="text-caption">
            {{ $t("microsite.textLuckyDrawClaimed") }}
            <!-- คุณเลือกสิทธิ์ Lucky Draw ในแคมเปญนี้แล้ว -->
            <br />
            {{ $t("microsite.textContactAdminToChange") }}
            <!-- หากต้องการเปลี่ยนสิทธิ์ กรุณาติดต่อเจ้าหน้าที่ -->
          </span>
        </v-alert>

        <v-card flat color="white" class="pa-2">
          <v-simple-table fixed-header style="overflow: scroll">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">{{ $t("microsite.textRank") }}</th>
                  <th class="text-center">{{ $t("microsite.textPhone") }}</th>
                  <th class="text-center">{{ $t("microsite.textTotal") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(spender, index) in topSpenders"
                  :key="index"
                  v-bind:style="[
                    spender.isRank
                      ? {
                          backgroundColor: '#FFFFFF',
                          boxShadow:
                            'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
                        }
                      : index + 1 > top_spender_display
                      ? {
                          backgroundColor: '#F3F3F3',
                          opacity: '0.5',
                        }
                      : index + 1 > top_spender_number &&
                        index + 1 <= top_spender_display
                      ? {
                          backgroundColor: '#F3F3F3',
                          opacity: '0.5',
                        }
                      : {
                          backgroundColor: '#FFFFFF',
                        },
                  ]"
                >
                  <td class="text-center">
                    <div v-if="spender.isMoreThanTop">
                      . <br />
                      . <br />
                      . <br />
                    </div>
                    <v-row class="d-flex justify-center align-center" v-else>
                      <div v-if="site.id == 391">
                        <div
                          v-if="spender.isRank"
                          style="
                            margin-right: 4px;
                            text-align: center;
                            font-size: 12px;
                            font-weight: 500;
                            line-height: 1;
                            color: #ff9800;
                          "
                        >
                          Your Ranking :
                        </div>
                      </div>
                      <div v-else>
                        <v-icon
                          v-if="spender.isRank"
                          data-testid="my-rank-icon"
                          color="#FBC02D"
                          class="ma-1"
                        >
                          mdi-chevron-triple-right
                        </v-icon>
                      </div>
                      <div
                        data-testid="rank-value"
                        :style="{
                          fontWeight:
                            index + 1 <= top_spender_number ? '700' : '',
                        }"
                      >
                        {{ spender.rank }}
                      </div>
                    </v-row>
                  </td>
                  <td class="text-center">
                    <div
                      v-if="spender.isMoreThanTop != true"
                      :style="{
                        fontWeight:
                          index + 1 <= top_spender_number ? '700' : '',
                      }"
                    >
                      {{ spender.phone }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div
                      v-if="spender.isMoreThanTop != true"
                      data-testid="total-value"
                      :style="{
                        fontWeight:
                          index + 1 <= top_spender_number ? '700' : '',
                      }"
                    >
                      {{
                        Number.parseFloat(spender.total).toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

        <div>
          <v-btn
            data-testid="btn-back"
            color="black"
            class="text-center white--text mt-8"
            width="100"
            height="40"
            rounded
            @click="handleRedirectMenu"
          >
            {{ $t("microsite.textBack") }}
          </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { Model } from "survey-core";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import moment from "moment";
import {
  addClassQlEditorToSDDisplay,
  customThemeSurveyJS,
} from "../../../config/general-function";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

// moment.locale("en");

export default {
  name: "MicrositeTopSpender",
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: null,
    survey: null,
    themeJson: null,
    topSpenders: null,
    surveyJson: null,
    logoHeight: null,
    tab: 1,
    adjacentCompetitors: {
      above: null,
      below: null,
    },
    currentUser: null,
    isMoreThanTop: false,
    currentUserRanking: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    top_spender_number: null,
    top_spender_display: null,
    userData: {},

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    this.getSurveyAndTheme();

    await this.getHeaderAndTopSpender();
    await this.getAdjacentCompetitors();

    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;
    this.setLogoHeight();
    // ========== ========== ========== ==========
    addClassQlEditorToSDDisplay();
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    handleRedirectMenu() {
      this.$router.push({
        name: "microsite-menu",
        params: { id: this.$route.params.id },
      });
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.topSpender) {
        this.surveyJson = surveyJson.topSpender;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).topSpender;
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    async getHeaderAndTopSpender() {
      try {
        const response = await MicrositeAxios.get(
          `getTopSpender/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );

        const userExists = response?.data?.data?.user;
        if (userExists) {
          this.userData = userExists;
          this.topSpenders = response.data.data.topSpender;
          this.top_spender_number = response.data.data.limit_topSpender;
          this.top_spender_display =
            response.data.data.limit_display_topSpender;

          if (
            this.topSpenders.length != 0 &&
            this.topSpenders.length < this.userData.currentRank &&
            this.userData.total != 0
          ) {
            if (this.userData.highScore != null) {
              let isMoreThanTop =
                this.topSpenders.length == this.userData.currentRank - 2
                  ? false
                  : true;
              if (isMoreThanTop) {
                this.topSpenders.push({
                  rank: "",
                  isMoreThanTop: isMoreThanTop,
                  phone: "",
                  total: "",
                  isRank: false,
                  created_at: "",
                });
              }

              this.topSpenders.push({
                rank: this.userData.highScore.rank,
                phone: this.userData.highScore.phone,
                total: this.userData.highScore.total,
                isRank: this.userData.highScore.isRank,
                created_at: this.userData.highScore.created_at,
              });
            }
            if (
              !(
                this.userData.choose_lucky_draw &&
                !this.campaign.is_split_lucky_draw_top_ranking
              )
            ) {
              this.topSpenders.push({
                rank: this.userData.rank,
                phone: this.userData.phone,
                total: this.userData.total,
                isRank: true,
                created_at: this.userData.created_at,
              });
            }
          } else {
            if (
              this.userData.choose_lucky_draw &&
              !this.campaign.is_split_lucky_draw_top_ranking
            ) {
              this.topSpenders[this.userData.currentRank - 1].isRank = false;
            } else if (
              this.topSpenders.length >
              this.userData.currentRank - 1
            ) {
              this.topSpenders[this.userData.currentRank - 1].isRank = true;
            }
          }
        } else {
          this.$swal
            .fire({
              icon: "error",
              title: this.$t("microsite.dataNotFound"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-login" });
          });
        console.log(error);
      }
    },
    async getAdjacentCompetitors() {
      try {
        const response = await MicrositeAxios.get(
          `getCompetitors/${this.campaign.id}?phone=${encodeURIComponent(
            this.user.phone
          )}`
        );

        const userExists = response?.data?.data?.user;
        if (userExists) {
          this.currentUser = userExists;
          this.adjacentCompetitors.above = response.data.data.highScore;
          this.adjacentCompetitors.below = response.data.data.lowScore;
          this.currentUserRanking = response.data.data.currentRank;
        } else {
          this.$swal
            .fire({
              icon: "error",
              title: this.$t("microsite.dataNotFound"),
              showConfirmButton: true,
            })
            .then(() => {
              this.$router.push({ name: "microsite-login" });
            });
        }
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            title: this.$t("microsite.errGeneral"),
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-login" });
          });
        console.log(error);
      }
    },
    setLogoHeight() {
      this.survey.onAfterRenderQuestion.add((_sender, options) => {
        if (options.question.name === "logo") {
          if (options.question.name === "logo") {
            const imageElement =
              options.htmlElement.querySelector(".sd-image__image");
            if (imageElement) {
              console.log("imageElement :>> ", imageElement);
              const setHeight = () => {
                const height = imageElement.getBoundingClientRect().height;
                this.logoHeight = height + 30;
              };

              if (imageElement.complete) {
                setHeight();
              } else {
                imageElement.addEventListener("load", setHeight);
              }
            }
          }
        }
      });
      console.log("this.logoHeight :>> ", this.logoHeight);
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm:ss");
      } else {
        label = date.format("DD MMM YY, HH:mm:ss");
      }
      return label;
    },
    formatDataTable: function (value) {
      if (!value) return "-";
      return value;
    },
  },
};
</script>

<style scoped>
table {
  width: 100%;
  table-layout: fixed;
  background-color: white;
  border-spacing: 0;
  /* display: block; */
  margin: 0 auto;
  white-space: nowrap;
}

th {
  border-bottom: 1px solid black;
  padding: 0;
  font-weight: 600;
  font-size: 11px;
  /* min-width: 60px; */
  font-size: clamp(0.7rem, 1.5vw, 1rem);
}

tr {
  font-size: 11px;
  height: 42px;
  /* min-width: 60px; */
  font-size: clamp(0.6rem, 1.2vw, 0.9rem);
}

.header-rank,
.body-rank {
  border-right: 1px solid black;
  width: 10%;
}

.header-name,
.body-name {
  border-right: 1px solid black;
  width: 40%;
}

.header-phone,
.body-phone {
  border-right: 1px solid black;
  width: 30%;
}

.header-total-spend,
.body-total-spend {
  width: 20%;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}
/* add-on */
::v-deep .sd-body {
  padding-bottom: 0px !important;
}
::v-deep .sd-navigation__complete-btn {
  display: none;
}
::v-deep .sd-action-bar {
  display: none;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
